<template>
  <section>
    <top-header />
    <router-view />
    <bottom-footer />
  </section>
</template>
<script>
  import TopHeader from '@/components/TopHeader';
  import BottomFooter from '@/components/BottomFooter';
  export default {
    name: 'Index',
    data() {
      return {

      }
    },
    components: {
      TopHeader,
      BottomFooter
    },
    mounted() {
      document.documentElement.onclick = () => {
        eventBus.$emit('hideServiceNav')
      }
    }
  }
</script>
<style scoped lang='scss'>
  
</style>



// WEBPACK FOOTER //
// src/views/index.vue